
import React, { useState } from 'react';
import { TextField, Typography, Box, Grid } from '@mui/material';

// const getRating = (value) => {
//     value = Number(value); // force numeric
//     if (value >= 96 && value <= 100) {
//         return 'OUTSTANDING';
//     } else if (value >= 80 && value <= 95) {
//         return 'MEETS ALL EXPECTATIONS';
//     } else if (value >= 61 && value <= 79) {
//         return 'MEETS MOST EXPECTATIONS';
//     } else {
//         return 'BELOW EXPECTATION';
//     }
// };

// const getRating = (value) => {
//     value = Number(value); // force numeric
//     if (value >= 96 && value <= 100) {
//         return 'OUTSTANDING';
//     } else if (value >= 80 && value <= 95) {
//         return 'MEETS ALL EXPECTATIONS';
//     } else if (value >= 61 && value <= 79) {
//         return 'MEETS MOST EXPECTATIONS';
//     } else {
//         return 'BELOW EXPECTATION';
//     }
// };

const getRating = (value) => {
    if (value === null || value === "") return "";
    
    value = Number(value); // force numeric
    if (value >= 96 && value <= 100) {
        return 'OUTSTANDING';
    } else if (value >= 80 && value <= 95) {
        return 'MEETS ALL EXPECTATIONS';
    } else if (value >= 61 && value <= 79) {
        return 'MEETS MOST EXPECTATIONS';
    } else {
        return 'BELOW EXPECTATION';
    }
};
const DepartmentPMSRating = ({ responseShowData, getKraKpiAppraisalForm, reviewerScore, setReviewerScore }) => {
    // const [reviewerScore, setEmployeeScore] = useState('');
    // const [reviewerScore, setReviewerScore] = useState('');
    // const [reviewerScore, setRecviewerScore] = useState('');


    const handleScoreChange = (value, setScore) => {
        if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
            setScore(value);
        }
    };

    return (
        <Box>
            {/* Employee Section */}
            <Grid container spacing={2}>
                <>
                    <Grid size={{ xs: 12, md: 6 }}>

                        <Typography variant="h6">Employee Rating:</Typography>
                        <Box bgcolor="#2980b9" color="#fff" p={1.5} borderRadius={1} mb={2} sx={{
                            height: "45px",
                            fontWeight: "600",

                        }}>
                            {/* {getRating(Number(employeeScore))} */}
                            {getKraKpiAppraisalForm?.data?.employee_rating}
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>


                        <Typography variant="h6">Employee PMS Score:</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            type="number"
                            disabled={getKraKpiAppraisalForm?.data?.appraisal_current_status === "manager evaluation ccompleted" || getKraKpiAppraisalForm?.data?.manager_appraisal_score_editable}
                            value={getKraKpiAppraisalForm?.data?.employee_pms_score || "--"}
                            // onChange={(e) => handleScoreChange(e.target.value, setEmployeeScore)}
                            inputProps={{ min: 0, max: 100 }}
                            // sx={{ backgroundColor: '#2980b9', input: { color: '#fff' } }}
                            sx={{
                                backgroundColor: '#2980b9', input: { color: 'white' }, height: "45px",
                                borderRadius: "5px",
                                color: "white",


                                '& .MuiOutlinedInput-input': {
                                    color: 'white',
                                    padding: '12.5px',
                                    border: "none",
                                    borderRadius: "10px",
                                    fontSize: "14px",
                                    fontWeight: "800",
                                    '&.Mui-disabled': {
                                        opacity: 1, // ensures full visibility
                                        WebkitTextFillColor: 'white', // override default gray
                                    }
                                },
                            }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>

                        <Typography variant="h6">Manager Rating:</Typography>
                        <Box bgcolor="#2980b9" color="#fff" p={1.5} borderRadius={1} mb={2} sx={{
                            height: "45px",
                            fontWeight: "600",

                        }}>
                            {getKraKpiAppraisalForm?.data?.manager_rating || getRating(reviewerScore)}
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>


                        <Typography variant="h6">Manager PMS Score:</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            type="number"
                            disabled={getKraKpiAppraisalForm?.data?.appraisal_current_status === "manager evaluation ccompleted" || getKraKpiAppraisalForm?.data?.manager_appraisal_score_editable}
                            value={getKraKpiAppraisalForm?.data?.manager_pms_score}
                            // onChange={(e) => handleScoreChange(e.target.value, setReviewerScore)}
                            inputProps={{ min: 0, max: 100 }}
                            // sx={{ backgroundColor: '#2980b9', input: { color: '#fff' } }}
                            sx={{
                                backgroundColor: '#2980b9', input: { color: '#fff' }, height: "45px",
                                borderRadius: "5px",


                                '& .MuiOutlinedInput-input': {
                                    color: '#fff',
                                    padding: '12.5px',
                                    border: "none",
                                    borderRadius: "10px",
                                    fontSize: "14px",
                                    fontWeight: "800",
                                    '&.Mui-disabled': {
                                        opacity: 1, // ensures full visibility
                                        WebkitTextFillColor: 'white', // override default gray
                                    }
                                },
                            }}
                        />
                    </Grid>
                    {
                        !getKraKpiAppraisalForm?.data?.manager_appraisal_score_editable && (
                            <>
                                <Grid size={{ xs: 12, md: 6 }}>

                                    <Typography variant="h6">Reviewer Rating:</Typography>
                                    <Box bgcolor="#2980b9" color="#fff" p={1.5} borderRadius={1} mb={2} sx={{
                                        height: "45px",
                                        fontWeight: "600",

                                    }}>
                                        {getKraKpiAppraisalForm?.data?.reviewer_rating || getRating(reviewerScore)}
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>


                                    <Typography variant="h6">Reviewer PMS Score:</Typography>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        type="number"
                                        disabled={getKraKpiAppraisalForm?.data?.appraisal_current_status === "reviewer evaluation completed"}
                                        value={getKraKpiAppraisalForm?.data?.reviewer_pms_score || reviewerScore}
                                        onChange={(e) => handleScoreChange(e.target.value, setReviewerScore)}
                                        inputProps={{ min: 0, max: 100 }}
                                        // sx={{ backgroundColor: '#2980b9', input: { color: '#fff' } }}
                                        sx={{
                                            backgroundColor: '#2980b9', input: { color: '#fff' }, height: "45px",
                                            borderRadius: "5px",


                                            '& .MuiOutlinedInput-input': {
                                                color: '#fff',
                                                padding: '12.5px',
                                                border: "none",
                                                borderRadius: "10px",
                                                fontSize: "14px",
                                                fontWeight: "800",
                                                '&.Mui-disabled': {
                                                    opacity: 1, // ensures full visibility
                                                    WebkitTextFillColor: 'white', // override default gray
                                                }
                                            },
                                        }}
                                    />
                                </Grid>

                            </>
                        )}

                </>

            </Grid >

        </Box >
    );
};

export default DepartmentPMSRating;
